import React from 'react'
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogProps,
  IconButton,
  Typography,
  useTheme,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { grey } from '@material-ui/core/colors'
import AlertDialogTitle from 'baby-ui/compounds/AlertDialog/AlertDialogTitle'

export interface AlertDialogProps extends DialogProps {
  children: React.ReactNode
  onClose?: React.MouseEventHandler<HTMLElement>
  open: boolean
  title: string
}

export default function AlertDialog({
  open,
  title,
  onClose,
  children,
  ...rest
}: AlertDialogProps) {
  const theme = useTheme()

  return (
    <Dialog
      aria-describedby="alert-dialog-description"
      aria-labelledby="alert-dialog-title"
      open={open}
      {...rest}
    >
      <Box
        component={AlertDialogTitle}
        id="alert-dialog-title"
        sx={{
          padding: 2,
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="h6">{title}</Typography>
        {onClose && (
          <Box
            aria-label="close"
            color={grey[500]}
            component={IconButton}
            sx={{ position: 'relative', left: theme.spacing(2) }}
            onClick={onClose}
          >
            <CloseIcon />
          </Box>
        )}
      </Box>

      <DialogContent>
        <DialogContentText
          color="primary"
          component="div"
          id="alert-dialog-description"
        >
          {children}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}
